import { Modal, ModalProps } from 'antd';

import { IMilesFormProps, MilesForm } from 'components';

interface IFormModal {
  underTitleNode?: React.ReactNode;
}

export const FormModal = <T, >({
  form,
  name,
  open,
  colon,
  title,
  fields,
  layout,
  labelCol,
  children,
  underTitleNode,
  wrapperCol,
  initialValues,
  buttonProps,
  onFinish,
  onCancel,
}: IFormModal & Omit<ModalProps, 'form'> & IMilesFormProps<T>) => (
  <Modal
    destroyOnClose
    open={open}
    title={title}
    footer={null}
    onCancel={onCancel}
  >
    {underTitleNode}

    <MilesForm
      form={form}
      name={name}
      colon={colon}
      fields={fields}
      layout={layout}
      labelCol={labelCol}
      onFinish={onFinish}
      wrapperCol={wrapperCol}
      buttonProps={buttonProps}
      initialValues={initialValues}
    />

    {children}
  </Modal>
);
